import { ChecklistPhase, ChecklistTaskStatus } from '@inversor-hub/types';
import { Assignment, AccountBalance, Gavel, Build, Home } from '@mui/icons-material';

export const PHASE_CONFIG: Record<
  ChecklistPhase,
  {
    label: string;
    icon: typeof Assignment;
    color: string;
    description: string;
  }
> = {
  PRESENTATION: {
    label: 'Presentación',
    icon: Assignment,
    color: '#1976d2',
    description: 'Documentación inicial y contrato de arras',
  },
  MORTGAGE: {
    label: 'Hipoteca',
    icon: AccountBalance,
    color: '#7b1fa2',
    description: 'Tasación, FEIN y documentación bancaria',
  },
  PURCHASE: {
    label: 'Compraventa',
    icon: Gavel,
    color: '#d32f2f',
    description: 'Firma de escrituras y transferencia de propiedad',
  },
  REFURB: {
    label: 'Reforma',
    icon: Build,
    color: '#f57c00',
    description: 'Trabajos de renovación y acondicionamiento',
  },
  RENTAL: {
    label: 'Alquiler',
    icon: Home,
    color: '#388e3c',
    description: 'Preparación y formalización del contrato de alquiler',
  },
};

export const STATUS_CONFIG: Record<
  ChecklistTaskStatus,
  {
    label: string;
    color: 'default' | 'success' | 'warning' | 'error' | 'info';
  }
> = {
  PENDING: {
    label: 'Pendiente',
    color: 'warning',
  },
  DONE: {
    label: 'Completado',
    color: 'success',
  },
  SKIPPED: {
    label: 'Omitido',
    color: 'default',
  },
};

export const PHASE_ORDER: ChecklistPhase[] = [
  'PRESENTATION',
  'MORTGAGE',
  'PURCHASE',
  'REFURB',
  'RENTAL',
];

export const ANCHOR_LABELS = {
  SIGNING_DATE: 'Fecha de firma de arras',
  FEIN_DATE: 'Fecha FEIN',
  CLOSING_DATE: 'Fecha de compraventa',
  MOVE_IN_DATE: 'Fecha de entrada (alquiler)',
  ARRAS_EXPIRY_DATE: 'Fecha de expiración de arras',
};
